
import React from 'react';
import { Logo } from './Logo';

interface NavbarProps {
  onNavigate: (view: 'home' | 'pilot' | 'privacy' | 'terms') => void;
  currentView: 'home' | 'pilot' | 'privacy' | 'terms';
}

export const Navbar: React.FC<NavbarProps> = ({ onNavigate, currentView }) => {
  const BOOKING_URL = "https://outlook.office.com/bookwithme/user/00ab44e829054d0caf6074d9ffaa2153@groflex.ai/meetingtype/0S1TPXwvgk2Nip5dsFYVgQ2?anonymous&ismsaljsauthenabled&ep=mcard";

  const handleHomeClick = () => {
    if (currentView === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      onNavigate('home');
    }
  };

  const handleAnchorClick = (id: string) => {
    if (currentView !== 'home') {
      onNavigate('home');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 50);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md text-zodiac py-4 px-6 md:px-12 flex justify-between items-center border-b border-zodiac/5 shadow-sm">
      <div className="flex items-center space-x-12">
        <button 
          onClick={handleHomeClick}
          className="hover:opacity-80 transition-opacity"
        >
          <Logo className="h-7 md:h-8" />
        </button>
        <div className="hidden lg:flex space-x-10 text-[11px] uppercase tracking-[0.2em] font-bold opacity-60">
          <button 
            onClick={handleHomeClick}
            className={`transition-executive hover:opacity-100 ${currentView === 'home' ? 'text-accent opacity-100' : 'hover:text-accent'}`}
          >
            HOME
          </button>
          <button 
            onClick={() => handleAnchorClick('platform')}
            className="hover:text-accent hover:opacity-100 transition-executive"
          >
            PRODUCT
          </button>
          <button 
            onClick={() => handleAnchorClick('solutions')}
            className="hover:text-accent hover:opacity-100 transition-executive"
          >
            SOLUTION
          </button>
          <button 
            onClick={() => onNavigate('pilot')}
            className={`transition-executive hover:opacity-100 ${currentView === 'pilot' ? 'text-accent opacity-100' : 'hover:text-accent'}`}
          >
            ENTERPRISE PILOT
          </button>
        </div>
      </div>
      <div className="flex items-center space-x-8">
        <button className="hidden sm:block text-[11px] uppercase tracking-[0.2em] font-bold opacity-60 hover:opacity-100 hover:text-accent transition-executive">Log In</button>
        <button 
          onClick={() => window.open(BOOKING_URL, '_blank')}
          className="bg-zodiac text-white hover:bg-accent px-6 py-2.5 rounded font-bold text-[10px] uppercase tracking-[0.15em] transition-executive shadow-lg shadow-zodiac/10"
        >
          BOOK A CALL
        </button>
      </div>
    </nav>
  );
};
